<template>
  <message-box
    v-if="displayNoteMsgBox"
    title="New note"
    submit-text="Send notes"
    type="orange"
    :disable-submit="message ? false : true"
    @on-close="setDisplayMsgBox(false)"
    @on-cancel="handleCancelMessage"
    @on-submit="handleSubmitMessage"
  >
    <div class="message-contents-field">
      <NrFormLabel>Note contents</NrFormLabel>
      <nr-editor
        v-model="message"
        :resizable="false"
        :placeholder="'Type your message here.'"
        :rows="10"
        strike
        bulletList
        orderedList
        link
      />
      <p class="is-size-7 m-bottom-12">
        This message will be visible to staff only and will only post to the
        request timeline.
      </p>
      <div v-if="shouldShowPinOption" class="pin-checkbox-field">
        <NrFormInput
          @change="changedPin"
          class="pin-checkbox"
          label="Pin this note above the timeline"
          type="checkbox"
          aria-labelledby="pin-note-label"
          aria-label="Pin this note above the timeline"
        />
      </div>
    </div>
  </message-box>
</template>

<script lang="ts">
import MessageBox from '@nextrequestco/components/src/components/MessageBox'
import NrEditor from '@nextrequestco/components/src/components/NrEditor'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput'
import { mapActions, mapState } from 'vuex'
import { State } from 'src/store/globalModule'

export default {
  name: 'NoteMessageModal',
  components: { MessageBox, 'nr-editor': NrEditor, NrFormLabel, NrFormInput },

  data() {
    return {
      message: '',
      pin: false
    }
  },
  computed: {
    ...mapState({
      hasPinningNotesEnabled: (state: State) =>
        !!(state.account && state.account.pinning_notes_feature_flag)
    }),

    ...mapState('request_show', ['displayMsgBox', 'currentAction', 'request']),

    shouldShowPinOption(): boolean {
      return (
        this.hasPinningNotesEnabled && this.$can('create', 'RequestEventPin')
      )
    },

    displayNoteMsgBox(): boolean {
      return this.displayMsgBox && this.currentAction === 'edit'
    }
  },

  methods: {
    ...mapActions('request_show', [
      'setDisplayMsgBox',
      'submitInternalMessage'
    ]),

    handleCancelMessage(): void {
      this.message = ''
      this.pin = false
      this.setDisplayMsgBox(false)
    },

    handleSubmitMessage(): void {
      this.submitInternalMessage({
        note_text: this.message,
        request_id: this.request.pretty_id,
        state: 'staff',
        note_type: 'request-note',
        note_pinned: this.pin
      }).then(() => {
        this.handleCancelMessage()
      })
    },

    async changedPin(event) {
      this.pin = event.target.checked
    }
  }
}
</script>

<style lang="scss">
.message-box {
  .message-contents-field,
  .editor-field {
    display: flex;
    flex-direction: column;
    flex: 0 1 100%;
  }

  .nr-editor {
    flex: 1 1 auto;
  }
}
</style>
